
import axios, { AxiosResponse } from "axios";
import ServerResult from "../../models/dtos/base/ServerResult";
import { PeriodDateJson } from "../../models/dtos/chart/PeriodDateJson";
import BaseService from "../base/BaseService";

export default class GlobalSerivce extends BaseService {
    getPeriodDate(): Promise<PeriodDateJson[]> {
        return axios.get( `/Global/GetPeriodDate`)
            .then(function (response: AxiosResponse<ServerResult<PeriodDateJson[]>, any>) {
                return response.data.data;
            });
    }
}